import { render } from "./ssq-wind-matrix.vue?vue&type=template&id=5a1ddbc9&scoped=true"
import script from "./ssq-wind-matrix.vue?vue&type=script&lang=js"
export * from "./ssq-wind-matrix.vue?vue&type=script&lang=js"

import "./ssq-wind-matrix.vue?vue&type=style&index=0&id=5a1ddbc9&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1ddbc9"]])

export default __exports__